//extracted by mini-css-extract-plugin
export default {"nav":"styles_nav__Zdj00","landingWrapper":"styles_landingWrapper__lxRAR","logo":"styles_logo__xgVzW","login":"styles_login__9nQRY"};;